export class ProductBatch {
    constructor() {
        this.batchName='' ,
        this.manufactureDate='',
        this.expireryDate='',
        this.productId='',
        this.productBachUnitDetails=[]
        this.has_expiry_date=false
    }
}
